export default __webpack_public_path__ + "static/media/abf.625bb079.svg";